<template lang="pug">
  include ../mixins
  +b.g-row
    multiselect.lang-multiselect(
      :class="itemClass"
      :options="languages"
      :hide-selected="true"
      v-model="language"
      track-by="value"
      label="label"
      name="lang"
      :allow-empty="false"
      @input="changeLanguage"
    )
</template>

<script>
import { DEFAULT_LANGUAGE, removeLanguage, generateHref } from '@/js/helpers/url'
import { restoreObject } from '@/js/helpers/utils'

export default {
  name: 'language-control',

  props: {
    itemClass: String,
    /*
      list of language codes to hide from the control,
      e.g. :exclude-languages="['ru']" in the profile cabinet
    */
    excludeLanguages: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentLang: window.language,
      language: {},
      languages: [
        { value: 'uk', label: this._('UA') },
        { value: 'en', label: this._('EN') },
        { value: 'ru', label: this._('RU') },
      ],
      polishSiteUrl: window.polishSiteUrl,
    }
  },

  mounted() {
    this.compareLangPrefixes()
    this.setPolishLink()
    this.filterLanguages()
  },

  methods: {
    /*
      hide languages passed via the excludeLanguages prop,
      but keep the currently active one so the control stays filled
    */
    filterLanguages() {
      if (!this.excludeLanguages.length) return

      this.languages = this.languages.filter(item => (
        !this.excludeLanguages.includes(item.value) || item.value === this.currentLang
      ))
    },

    setPolishLink() {
      if (this.polishSiteUrl) {
        this.languages.push({ value: 'pl', label: 'PL' })
      }
    },

    /*
      parse language code from url
      to show it in the control
    */
    compareLangPrefixes() {
      const path = window.location.pathname
      const [, lang] = path.split('/')
      this.currentLang = 2 === lang.length ? lang : DEFAULT_LANGUAGE
      this.language = restoreObject(this.languages, 'value', this.currentLang)
    },

    changeLanguage() {
      const selectedLang = this.language.value

      if ('pl' === selectedLang) {
        window.location = this.polishSiteUrl

        return
      }

      const urlObj = {
        origin: window.location.origin,
      }
      const location = window.location.pathname
      if (selectedLang !== DEFAULT_LANGUAGE) urlObj.lang = selectedLang
      else urlObj.lang = ''
      urlObj.path = removeLanguage(location)
      this.redirect(generateHref(urlObj))
    },

    redirect(url) {
      window.location.replace(decodeURIComponent(url))
    },
  },
}
</script>
